<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { computed } from "vue";

const { tm } = useI18n();

const instructions = computed(
  () => tm("calculators.tarot.situation-prediction.instruction") as unknown
);
</script>

<template>
  <div class="flex flex-col text-left text-brown">
    <h4 class="font-semibold text-xl leading-[24px] mb-6">
      {{ instructions.first_title }}
    </h4>
    <p class="text-base font-normal leading-[20px] mb-6">
      {{ instructions.first_paragraph }}
    </p>
    <h6 class="font-medium text-base leading-100p mb-4">
      {{ instructions.second_title }}
    </h6>
    <ul
      class="list-disc pl-7 text-left text-brown text-base leading-[20px] mb-4"
    >
      <li v-for="(item, i) in instructions.list" :key="i">
        <span class="font-bold">{{ item.bold }}</span>
        {{ item.text }}
      </li>
    </ul>
  </div>
</template>
